import { DownloadButton } from 'designsystem/components/1-atoms/Buttons';
import { fireAdobeEvent } from 'helpers/adobeEvent';
import getConfig from 'next/config';
import { BackgroundContainerFeature } from '../BackgroundContainer';
import { ImageContentFeature } from '../ImageContent';

export const DownloadButtonFeature: React.FC<Content.DownloadButton> = ({ content, noBackground = false }) => {
	const { picture, label, file, mediaPicture } = content?.properties ?? {};
	const { CONTENT_API_URL } = getConfig()?.publicRuntimeConfig ?? {};
	const imageObj = (
		mediaPicture?.items?.length > 0
			? mediaPicture?.items?.[0].content?.properties?.picture?.items?.[0]?.content?.properties?.image ?? []
			: picture?.items?.length > 0
			? picture?.items?.[0]?.content?.properties?.image ?? []
			: [undefined]
	)[0];
	const fileType = imageObj ? imageObj?.extension : file?.[0]?.extension;
	const getFileName = (value: string) => {
		return value?.substring(value.lastIndexOf('/')).split('.').at(0).replace('/', '');
	};
	const fileName = imageObj ? getFileName(imageObj.properties?.umbracoFile) : file?.[0]?.name;
	const onClick = () => {
		fireAdobeEvent('file_download', { fileName: fileName, fileType: fileType });
	};
	const relativeUrl = (imageObj ? imageObj?.url : file?.[0]?.url)?.replace(CONTENT_API_URL, '/');

	return (
		<BackgroundContainerFeature enableBackground={!noBackground}>
			<DownloadButton
				downloadUrl={relativeUrl}
				label={label}
				onClick={onClick}
				displayComponent={
					mediaPicture?.items?.length > 0 && (
						<ImageContentFeature {...(mediaPicture?.items?.[0] as Content.ImageContent)} noBackground={true} />
					)
				}
			/>
		</BackgroundContainerFeature>
	);
};
